import { EPlanType } from '@if/core/types'
import { copyMessage } from '@if/core/utils'
import CopyAllIcon from '@mui/icons-material/CopyAll'
import { Grid, IconButton } from '@mui/material'
import { InputTextField } from '@src/components'
import { AutoWorksheet, CreditApplication, Merchant } from '@src/data/types'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  worksheet: AutoWorksheet
  creditApplication: CreditApplication
  merchant: Merchant | null
}

const ProgramSection = ({ worksheet, creditApplication, merchant }: Props): JSX.Element | null => {
  const { t } = useTranslation()
  const plan =
    worksheet.brokerRequestedFinancingPlan ?? creditApplication.normsCreditDecision?.planName ?? EPlanType.Default

  return (
    <Grid container spacing={2} sx={{ display: 'flex', flexDirection: 'row', mt: 3, p: 2 }}>
      <Grid size={{ md: 4 }} sx={{ flexDirection: 'row' }}>
        <InputTextField label={t('worksheet.program')} disabled value={plan} />
      </Grid>
      <Grid size={{ md: 4 }} sx={{ flexDirection: 'row' }}>
        <InputTextField
          label="Province"
          disabled
          value={merchant?.province ? t(`EProvince.${merchant?.province}`, { ns: 'enum' }) : ''}
        />
      </Grid>
      <Grid size={{ md: 4 }} sx={{ flexDirection: 'row' }}>
        <InputTextField
          label={t('editCreditApplication.address.postalCode')}
          value={merchant?.zipCode}
          disabled
          slotProps={{
            input: {
              endAdornment: (
                <IconButton onClick={() => merchant?.zipCode && copyMessage(merchant?.zipCode)}>
                  <CopyAllIcon />
                </IconButton>
              ),
            },
          }}
        />
      </Grid>
    </Grid>
  )
}

export default ProgramSection
